import { Suspense } from 'react'
import { Route, Routes} from 'react-router-dom'
import Redirect from '@scrippsproduct/networks-ui-library/dist/utils/Redirect'
import BasePageLayout from './page-layouts/BasePageLayout'
import Home from './pages/Home'

import './scss/Settings.scss'
import './scss/Base.scss'

function Site() {
    return (
        <Suspense>
            <Routes>
                <Route path="/" element={<BasePageLayout />}>           
                    <Route index element={<Home />} key="home"/>
                    <Route path="*" element={<Redirect to="/" />} key="CatchAll" />
                </Route>
            </Routes>
        </Suspense>
    )
}

export default Site;
